// FICHIER GENERE — ne pas modifier a la main.
// Source : src/AppRoutes.tsx  ·  Regeneration : node scripts/generer-permissions-routes.js
//
// Permission exigee par chaque route protegee. Sert au menu lateral pour
// masquer les entrees inaccessibles, sans avoir a redeclarer le droit dans
// le composant de navigation.

export const PERMISSION_PAR_ROUTE: Record<string, string> = {
  '/accords-commerciaux': 'access_recouvrement',
  '/achats': 'access_achats',
  '/achats/cotations/:id': 'access_achats',
  '/admin/bancaire-reconciliation': 'access_finances',
  '/admin/baremes-frais-entree': 'authenticated',
  '/admin/cinetpay/historique': 'access_admin',
  '/admin/conventions-subvention': 'authenticated',
  '/admin/coupures': 'access_admin',
  '/admin/demandes-client': 'authenticated',
  '/admin/dev/modules': 'access_admin',
  '/admin/dev/types-operation': 'access_admin',
  '/admin/dev/types-operation/:code': 'access_admin',
  '/admin/form-templates': 'access_admin',
  '/admin/referentiel-devises': 'access_admin',
  '/admin/referentiels': 'access_admin',
  '/admin/templates-documents': 'access_admin',
  '/administration': 'access_admin',
  '/administration/alertes': 'access_admin',
  '/administration/axes-analytiques': 'access_admin',
  '/administration/espace-client': 'access_espace_client_admin',
  '/administration/referentiels-fiscaux': 'access_admin',
  '/agregateur': 'access_agregateur_paiement',
  '/alertes': 'access_alertes',
  '/assurance': 'access_assurance',
  '/assurance/dashboard': 'view_stats_assurance',
  '/bilan-periodique': 'access_statistics',
  '/bordereaux-intervention/:id': 'access_electricite',
  '/boutique/commandes-en-ligne': 'gerer_commandes_enligne',
  '/caisse': 'access_caisse',
  '/caisse/annulation': 'access_caisse',
  '/caisse/billetage': 'access_caisse',
  '/caisse/billetages/historique': 'access_caisse',
  '/caisse/ecarts': 'access_caisse',
  '/caisse/etats': 'access_caisse',
  '/caisse/legacy': 'access_caisse',
  '/caisse/paiement-salaires': 'access_caisse',
  '/caisse/reedition': 'access_caisse',
  '/caisse/remise-banque': 'access_caisse',
  '/caisse/remises': 'access_caisse',
  '/caisse/scolarite': 'access_caisse',
  '/caisse/validation-annulations': 'access_caisse',
  '/chantiers': 'access_chantier',
  '/clients': 'access_clients',
  '/clients/:id/vue-360': 'authenticated',
  '/comptabilite': 'access_comptabilite',
  '/comptabilite/rebalance': 'access_rebalance_ecritures',
  '/consignation': 'access_consignation',
  '/consolidation': 'access_consolidation_groupe',
  '/consolidation-electricite': 'access_consolidation_electricite',
  '/contacts': 'access_contacts',
  '/crm/abonnements': 'access_abonnements',
  '/crm/branchements': 'access_branchements',
  '/crm/clients/:clientId/fiche': 'access_clients',
  '/crm/dossiers-vente': 'access_dossiers_vente',
  '/crm/dossiers-vente/:id': 'access_dossiers_vente',
  '/crm/dossiers-vente/mes-actions': 'access_dossiers_vente',
  '/crm/enquetes-satisfaction': 'access_demandes_client',
  '/crm/enquetes-satisfaction/bilan': 'access_demandes_client',
  '/crm/enquetes-satisfaction/suivi-actions': 'access_demandes_client',
  '/crm/etat-activite': 'voir_etat_activite_crm',
  '/crm/etats': 'voir_etats_crm',
  '/crm/objectifs': 'gerer_objectifs_crm',
  '/crm/planning': 'access_planning_activite',
  '/crm/prospects': 'access_prospects',
  '/crm/rapports': 'access_clients',
  '/crm/rapports-a-valider': 'valider_rapport_crm',
  '/crm/rapports/:id': 'access_clients',
  '/crm/rapports/:id/modifier': 'access_clients',
  '/crm/rapports/nouveau': 'access_clients',
  '/crm/reclamations': 'access_reclamations',
  '/crm/reclamations/bareme-etalonnage': 'gerer_frais_etalonnage',
  '/dashboard': 'access_dashboard',
  '/db-sync': 'access_db_sync',
  '/decaissements-directs': 'access_decaissements',
  '/decaissements-directs/:id': 'access_decaissements',
  '/decaissements-directs/:id/print': 'access_decaissements',
  '/decaissements-directs/export': 'access_decaissements',
  '/decaissements-directs/nouveau': 'access_decaissements',
  '/decaissements/paiement-fournisseur': 'access_decaissements',
  '/decaissements/paiement-prestataire': 'access_decaissements',
  '/decaissements/paiement-tous': 'access_decaissements',
  '/demandes-decaissement': 'access_decaissements',
  '/demandes-decaissement/:id': 'access_decaissements',
  '/demandes-decaissement/modifier/:id': 'access_decaissements',
  '/demandes-decaissement/nouveau': 'access_decaissements',
  '/demandes-decaissement/paiement/:id': 'access_decaissements',
  '/demandes-decaissement/statistiques': 'access_decaissements',
  '/demandes-decaissement/validation/:id': 'access_decaissements',
  '/demandes-remboursement': 'access_demande_remboursement',
  '/devis': 'access_clients',
  '/dividendes/distributions': 'view_dividendes',
  '/edition': 'access_edition',
  '/espace-adherent': 'authenticated',
  '/evaluation-performance': 'access_evaluation_performance',
  '/facturation-electrique': 'access_facturation_electrique',
  '/facturation-electrique/bt': 'access_facturation_electrique',
  '/facturation-electrique/bt/:cycleId': 'access_facturation_electrique',
  '/facturation-electrique/calendrier': 'access_facturation_electrique',
  '/facturation-electrique/compteurs-intelligents': 'access_facturation_electrique',
  '/facturation-electrique/mt': 'access_facturation_electrique',
  '/facturation-electrique/mt/:cycleId': 'access_facturation_electrique',
  '/facturation-electrique/prepaye': 'access_facturation_electrique',
  '/factures-fournisseur': 'access_factures_fournisseur',
  '/factures-fournisseur/:id': 'access_factures_fournisseur',
  '/factures-fournisseur/:id/modifier': 'gerer_factures_fournisseur',
  '/factures-fournisseur/a-rapprocher': 'access_factures_fournisseur',
  '/factures-fournisseur/nouvelle': 'gerer_factures_fournisseur',
  '/finances/cash-pooling': 'manage_cash_pooling',
  '/finances/couverture-change': 'manage_couverture_change',
  '/fonds-epargne': 'access_fonds_epargne',
  '/gouvernance': 'access_gouvernance',
  '/immobilier': 'access_immobilier',
  '/immobilier/dashboard-consolide': 'access_immobilier',
  '/immobilisations': 'access_immobilisations',
  '/immobilisations/cartographie': 'access_immobilisations',
  '/immobilisations/cloture': 'access_immobilisations',
  '/immobilisations/credit-bail': 'access_immobilisations',
  '/immobilisations/etats': 'access_immobilisations',
  '/immobilisations/garanties': 'access_immobilisations',
  '/immobilisations/integrite': 'access_immobilisations',
  '/immobilisations/inventaires': 'access_immobilisations',
  '/immobilisations/inventaires/:id': 'access_immobilisations',
  '/immobilisations/maintenance': 'access_immobilisations',
  '/immobilisations/subventions': 'access_immobilisations',
  '/inventaire': 'access_inventaire',
  '/location': 'access_location',
  '/mode-couture': 'access_mode_couture',
  '/mon-espace/achats': 'authenticated',
  '/mon-espace/acompte': 'authenticated',
  '/mon-espace/acomptes': 'authenticated',
  '/mon-espace/bulletins': 'authenticated',
  '/mon-espace/demission': 'authenticated',
  '/mon-espace/evaluations': 'authenticated',
  '/mon-espace/ma-carriere': 'authenticated',
  '/mon-espace/ma-fiche': 'authenticated',
  '/mon-espace/ma-fiche-de-poste': 'authenticated',
  '/mon-espace/ma-fiche/modifier': 'authenticated',
  '/mon-espace/mes-demandes': 'authenticated',
  '/mon-espace/mes-enquetes': 'authenticated',
  '/mon-espace/mes-objectifs': 'authenticated',
  '/mon-espace/mon-cv': 'authenticated',
  '/mon-espace/pret': 'authenticated',
  '/mon-espace/prets': 'authenticated',
  '/niveaux-organisation': 'gerer_niveaux_organisation',
  '/parametrage/banques': 'access_admin',
  '/parametrage/baremes-mission': 'access_baremes_mission',
  '/parametrage/cours-devises': 'access_cours_devises',
  '/parametrage/operateurs-mobile-money': 'access_admin',
  '/parametrage/regroupements': 'gerer_regroupements',
  '/parametrage/relance-referentiels': 'access_admin',
  '/parametrage/tarifs-electriques': 'gerer_tarifs_electriques',
  '/pilotage': 'access_pilotage',
  '/plantation/*': 'access_plantation',
  '/profil': 'authenticated',
  '/promotions/*': 'access_promotions',
  '/prospects': 'access_prospects',
  '/recouvrement': 'access_facturation_electrique',
  '/rh/absences': 'authenticated',
  '/rh/absences/nouvelle': 'authenticated',
  '/rh/alertes': 'access_rh',
  '/rh/annonces': 'access_annonces_rh',
  '/rh/bordereaux-journaliers': 'access_rh',
  '/rh/bordereaux-stages': 'access_rh',
  '/rh/campagnes-primes': 'access_rh',
  '/rh/conges': 'authenticated',
  '/rh/conges/calendrier': 'view_calendrier_conges',
  '/rh/conges/nouveau': 'authenticated',
  '/rh/conges/validation': 'validate_conge',
  '/rh/contrats': 'access_contrats',
  '/rh/contrats/:id': 'access_contrats',
  '/rh/contrats/:id/modifier': 'create_contrat',
  '/rh/contrats/import': 'access_contrats',
  '/rh/contrats/nouveau': 'create_contrat',
  '/rh/dashboard': 'access_rh',
  '/rh/delegations': 'access_rh',
  '/rh/demandes': 'access_rh',
  '/rh/demandes-documents': 'access_demandes_documents',
  '/rh/demissions': 'access_demission',
  '/rh/disciplinaire': 'manage_rh_params',
  '/rh/disponibilite': 'access_disponibilite',
  '/rh/documents-entreprise': 'access_documents_entreprise',
  '/rh/employes': 'access_employes',
  '/rh/employes/:id': 'access_employes',
  '/rh/employes/:id/modifier': 'edit_employe',
  '/rh/employes/nouveau': 'create_employe',
  '/rh/enquetes': 'access_enquetes_rh',
  '/rh/etats': 'access_rh',
  '/rh/evaluations': 'access_evaluations_rh',
  '/rh/evaluations/:id': 'access_evaluations_rh',
  '/rh/evaluations/nouveau': 'create_evaluation_rh',
  '/rh/evenements': 'access_evenements_rh',
  '/rh/formations': 'authenticated',
  '/rh/formations/:id': 'authenticated',
  '/rh/formations/:id/inscriptions': 'manage_inscriptions',
  '/rh/formations/nouveau': 'authenticated',
  '/rh/gpec/etats': 'access_rh',
  '/rh/gpec/feedback-360': 'access_rh',
  '/rh/gpec/fiches-postes': 'access_rh',
  '/rh/gpec/matrice-competences': 'access_rh',
  '/rh/gpec/mobilite-interne': 'access_rh',
  '/rh/gpec/profils-carriere': 'access_rh',
  '/rh/gpec/risques': 'access_risques_rh',
  '/rh/gpec/succession': 'access_rh',
  '/rh/gpec/talents': 'access_gpec_talents',
  '/rh/medical': 'access_dossier_medical',
  '/rh/medical/arrets': 'authenticated',
  '/rh/medical/dossier/:employeId': 'access_dossier_medical',
  '/rh/medical/mon-dossier': 'authenticated',
  '/rh/mesures': 'access_disciplinaire',
  '/rh/organisation': 'access_rh',
  '/rh/organisation/postes/:id': 'access_rh',
  '/rh/organisation/postes/nouveau': 'access_rh',
  '/rh/organismes-sociaux': 'access_rh',
  '/rh/paie': 'access_paie',
  '/rh/paie/bordereau-paiement': 'access_paie',
  '/rh/paie/bulletin/:id': 'access_paie',
  '/rh/paie/bulletin/:id/edit': 'access_paie',
  '/rh/paie/ecritures-comptables': 'access_paie',
  '/rh/paie/generation': 'generate_paie',
  '/rh/paie/historique': 'access_paie',
  '/rh/parametres': 'manage_rh_params',
  '/rh/pointage': 'access_rh',
  '/rh/recrutement': 'access_recrutement',
  '/rh/recrutement/candidatures': 'manage_candidatures',
  '/rh/recrutement/candidatures/:id': 'manage_candidatures',
  '/rh/recrutement/entretiens': 'plan_entretiens',
  '/rh/relations-sociales': 'authenticated',
  '/rh/remuneration-mandataires': 'view_remuneration_mandataires',
  '/rh/tableau-de-bord': 'access_rh',
  '/rh/team-building': 'access_rh',
  '/securite/politique': 'access_politique_securite',
  '/sig/branchements': 'access_facturation_electrique',
  '/societe/associes': 'view_associes',
  '/societe/capital-social': 'view_associes',
  '/statistiques': 'access_statistics',
  '/stats-patronales': 'view_stats_patronales',
  '/stock': 'access_stock',
  '/stock/articles/:id/fiche': 'access_stock',
  '/stock/compteurs': 'access_stock',
  '/stock/demandes-sortie': 'access_demande_sortie',
  '/stock/demandes-sortie/:id': 'access_demande_sortie',
  '/stock/demandes-sortie/:id/modifier': 'edit_demande_sortie',
  '/stock/demandes-sortie/nouveau': 'create_demande_sortie',
  '/stock/disjoncteurs': 'access_stock',
  '/stock/motifs-sortie': 'gerer_motifs_sortie',
  '/stock/poteaux': 'access_stock',
  '/stock/scelles': 'access_stock',
  '/stock/transformateurs': 'access_stock',
  '/supervision': 'access_supervision',
  '/tableau-taches': 'authenticated',
  '/terrain/interventions': 'acces_intervention_terrain',
  '/terrain/interventions/:id': 'acces_intervention_terrain',
  '/terrain/releves': 'acces_releve_terrain',
  '/terrain/releves/:lotId': 'acces_releve_terrain',
  '/terrain/releves/:lotId/charge/:ligneId': 'acces_releve_terrain',
  '/terrain/releves/:lotId/saisie/:ligneId': 'acces_releve_terrain',
  '/vente-directe': 'access_caisse',
  '/vie-scolaire': 'access_vie_scolaire',
  '/vie-scolaire/annees-scolaires/:anneeId': 'access_vie_scolaire',
  '/vie-scolaire/besoins-speciaux': 'access_vie_scolaire',
  '/vie-scolaire/classes/:classeId': 'access_vie_scolaire',
  '/vie-scolaire/classes/:classeId/notes/:evalId': 'access_vie_scolaire',
  '/vie-scolaire/cursus/:cursusId': 'access_vie_scolaire',
  '/vie-scolaire/cursus/:cursusId/programme': 'access_vie_scolaire',
  '/vie-scolaire/ecoles/:ecoleId': 'access_vie_scolaire',
  '/vie-scolaire/ecoles/:ecoleId/abonnements-parents': 'access_vie_scolaire',
  '/vie-scolaire/ecoles/:ecoleId/annees': 'access_vie_scolaire',
  '/vie-scolaire/promotions/:promotionId': 'access_vie_scolaire',
  '/vie-scolaire/promotions/:promotionId/diplomes': 'access_vie_scolaire',
  '/vie-scolaire/remises': 'access_vie_scolaire',
};
